import { Box, Section, Text } from "@vinomofo/components";

import { COLORS } from "../../styles";
import { CartDropdown } from "../cart-dropdown";
import { HeaderAuth } from "./HeaderAuth";
import { HeaderCategoryNav } from "./HeaderCategoryNav";
import { HeaderLogo } from "./HeaderLogo";
import { HeaderSearch } from "./HeaderSearch";
import { storefrontNavigationItemProps } from "../../types/vino-data-types";
import styled from "styled-components";
import LoginSignup from "./LoginSignup";
import { isWhiskymofoSignupPage } from "../../utils/is-page";
import { useLocation } from "@reach/router";

const StyledToggleSwitchBox = styled(Box)`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 10px;
`;
const ToggleWrap = styled(Box)`
  width: 50px;
  height: 26px;
  border-radius: 20px;
  background-color: #303030;
  padding: 2px;
  border: 1px solid #777;
  cursor: pointer;
`;
const ToggleValue = styled(Box)<{ value: boolean }>`
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background-color: ${({ value }) =>
    value === true ? COLORS.mofoGold : COLORS.mofoGreen};
  float: ${({ value }) => (value === true ? "right" : "left")};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
`;

const WHISKYMOFO_ENABLED = process.env.GATSBY_ENABLE_WHISKYMOFO === "true";

export const SiteToggle = ({ value }: { value: boolean }) => {
  const url = value === true ? "/" : "/whiskymofo";

  return (
    <StyledToggleSwitchBox>
      <Text fontSize={"9px"} color="white" fontWeight="500">
        VINOMOFO
      </Text>
      <a href={url}>
        <ToggleWrap>
          <ToggleValue value={value}>{value ? "🥃" : "🍷"}</ToggleValue>
        </ToggleWrap>
      </a>
      <Text fontSize={"9px"} color="white" fontWeight="500">
        WHISKYMOFO
      </Text>
    </StyledToggleSwitchBox>
  );
};

export const HeaderWide = ({
  menuItems,
  isWhiskymofoEnabled,
  transparentHeader = false,
}: {
  menuItems: storefrontNavigationItemProps[];
  isWhiskymofoEnabled: boolean;
  transparentHeader: boolean;
}): JSX.Element => {
  const location = useLocation();
  return (
    <Section
      py={["15px", "20px", "20px"]}
      backgroundColor={transparentHeader ? "transparent" : "secondary"}
      borderBottom={
        transparentHeader ? ["1px solid rgba(255, 255, 255, .25)"] : 0
      }
    >
      <Box display="flex" alignItems="center" justifyContent="space-between">
        {WHISKYMOFO_ENABLED ? (
          <Box width={"33.3%"}>
            <SiteToggle value={isWhiskymofoEnabled} />
          </Box>
        ) : (
          <Box width={"33.3%"} flexGrow={3} flexShrink={1} flexBasis={0} />
        )}
        <Box
          width={"33.3%"}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <HeaderLogo
            height={["24px", "32px", "38px"]}
            isWhiskymofoEnabled={isWhiskymofoEnabled}
          />
        </Box>
        <Box
          as="nav"
          display="flex"
          width={"33.3%"}
          justifyContent="flex-end"
          alignItems="center"
          gridGap={[3, 3, 4]}
        >
          {isWhiskymofoSignupPage(location?.pathname) ? (
            <LoginSignup />
          ) : (
            <>
              <HeaderAuth isLarge />
              <HeaderSearch />
              <CartDropdown isLarge />
            </>
          )}
        </Box>
      </Box>
      {/* {withCategoryNavigation ? ( */}
      {menuItems.length > 0 && (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexBasis="100%"
          paddingTop="15px"
          position="relative"
        >
          <HeaderCategoryNav menuItems={menuItems} fontSize={[0, 1]} />
        </Box>
      )}
      {/* ) : null} */}
    </Section>
  );
};
